// @spec AST-STR-011
// @spec AST-STR-012
'use client';

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/controls')({
  component: ControlsLayout,
});

/**
 * Controls layout - Wrapper for all control routes.
 *
 * This layout renders child routes:
 * - /controls (index) - Control library list
 * - /controls/:controlId - Control detail page
 */
function ControlsLayout() {
  return <Outlet />;
}
